import { render, staticRenderFns } from "./TermsCard.vue?vue&type=template&id=f58508a8&scoped=true"
import script from "./TermsCard.vue?vue&type=script&lang=js"
export * from "./TermsCard.vue?vue&type=script&lang=js"
import style0 from "./TermsCard.vue?vue&type=style&index=0&id=f58508a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58508a8",
  null
  
)

export default component.exports